import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import leftIcon from 'assets/img/left-arrow-icon.svg';
import rightIcon from 'assets/img/right-arrow-icon.svg';
import { Paginate, List, ListItem } from './styles';

const Pagination = ({
  total, listMaxLength, offset, setOffset,
}) => {
  const showPagination = total > listMaxLength;
  const numberOfPages = total % listMaxLength !== 0 ? parseInt(total / listMaxLength) + 1 : total / listMaxLength;
  const offsetOfLastPage = numberOfPages * listMaxLength - listMaxLength;
  const prevPage = () => {
    if (offset > 0) setOffset(offset - listMaxLength);
  };

  const nextPage = () => {
    if (offset !== offsetOfLastPage) setOffset(offset + listMaxLength);
  };

  const changePageToOffset = (page) => {
    const offsetToGo = page * listMaxLength;
    if (offset !== offsetToGo) setOffset(offsetToGo);
  };

  const ListOfPages = () => {
    const pages = [];
    const actualPage = offset / listMaxLength;
    const starterIndex = numberOfPages <= 6 ? 0 : (actualPage || 1) - 1;
    const iteratingPages = numberOfPages <= 6 ? numberOfPages : starterIndex + 3;
    for (let index = starterIndex; index < iteratingPages; index++) {
      if (actualPage < numberOfPages && index != numberOfPages) {
        pages.push(
          <ListItem
            key={index}
            active={index === actualPage}
            onClick={() => changePageToOffset(index)}
          >
            {index + 1}
          </ListItem>,
        );
      }
    }
    return pages;
  };

  return (
    <Paginate>
      {showPagination && (
        <List>
          <ListItem onClick={prevPage}>
            <img src={leftIcon} alt="Left Icon" />
          </ListItem>
          {numberOfPages > 6 && offset / listMaxLength >= 3 && (
            <Fragment>
              <ListItem onClick={() => changePageToOffset(0)}>1</ListItem>
              <ListItem ellipsis>...</ListItem>
            </Fragment>
          )}
          <ListOfPages />
          {numberOfPages > 6 && offset / listMaxLength < numberOfPages - 3 && (
            <Fragment>
              <ListItem ellipsis>...</ListItem>
              <ListItem onClick={() => changePageToOffset(numberOfPages - 1)}>
                {numberOfPages}
              </ListItem>
            </Fragment>
          )}
          <ListItem onClick={nextPage}>
            <img src={rightIcon} alt="Right Icon" />
          </ListItem>
        </List>
      )}
    </Paginate>
  );
};

const mapStateToProps = state => ({});

// const mapDispatchToProps = dispatch =>
//   bindActionCreators(Actions, dispatch);

export default connect(
  mapStateToProps,
  // mapDispatchToProps
)(Pagination);
